<template>
    <div class="investors-gm">
        <p class="indent">The general meeting is the principal opportunity and ideal venue for shareholders to meet and exchange views on the Alcomet’s business with the Directors and the management.</p>
        <div class="gm-table-wrapper">
          <table class="gm-table">
            <thead>
              <tr class="gm-table-row">
                <td class="gm-table-main-title" colspan="2"><span>General meetings and reports</span></td>
              </tr>
            </thead>
            <tbody>
            <tr class="gm-table-row">
              <td class="gm-table-date">22.02.2019</td>
              <td class="gm-table-title">General Meeting of Alcomet's shareholders, 22.02.2019
                <br><a href="/static/files/general_meetings/dneven-red-22.02.2019.pdf" target="_blank" class="gm-table-link"><span class="alcomet gm-table-download">u</span><span class="gm-table-link-text">Agenda</span></a>
                <br><a href="/static/files/general_meetings/model-poa-22.02.2019.pdf" target="_blank" class="gm-table-link"><span class="alcomet gm-table-download">u</span><span class="gm-table-link-text">Power of authority </span></a>
                <br><a href="/static/files/general_meetings/pokana-22.02.2019.pdf" target="_blank" class="gm-table-link"><span class="alcomet gm-table-download">u</span><span class="gm-table-link-text">Invitation</span></a>
                <br><a href="/static/files/general_meetings/protocol-ok-22.02.2019.pdf" target="_blank" class="gm-table-link"><span class="alcomet gm-table-download">u</span><span class="gm-table-link-text">Protocol</span></a>
                <br><a href="/static/files/general_meetings/protokol-osa-22.02.2019.pdf" target="_blank" class="gm-table-link"><span class="alcomet gm-table-download">u</span><span class="gm-table-link-text">Protocol OSA 22.02.2019</span></a>
              </td>
            </tr>
              <tr class="gm-table-row">
                <td class="gm-table-date">14.06.2018</td>
                <td class="gm-table-title">General Meeting of Alcomet's shareholders from 14.06.2018
                  <br><a href="/static/files/general_meetings/protokol-osa-14.06.2018.pdf" target="_blank" class="gm-table-link"><span class="alcomet gm-table-download">u</span><span class="gm-table-link-text">Protocol of Shareholders' General Meeting</span></a>
                </td>
              </tr>
              <tr class="gm-table-row">
                <td class="gm-table-date">12.06.2017</td>
                <td class="gm-table-title">General Meeting of Alcomet's shareholders from 12.06.2017
                  <br><a href="/static/files/general_meetings/protokol-osa-12.06.2017.pdf" target="_blank" class="gm-table-link"><span class="alcomet gm-table-download">u</span><span class="gm-table-link-text">Protocol of Shareholders' General Meeting</span></a>
                </td>
              </tr>
              <tr class="gm-table-row">
                <td class="gm-table-date">27.05.2016</td>
                <td class="gm-table-title">General Meeting of Alcomet's shareholders from 27.05.2016
                  <br><a href="/static/files/general_meetings/protokol-osa-27.05.2016.pdf" target="_blank" class="gm-table-link"><span class="alcomet gm-table-download">u</span><span class="gm-table-link-text">Protocol of Shareholders' General Meeting</span></a>
                </td>
              </tr>
              <tr class="gm-table-row">
                <td class="gm-table-date">17.06.2015</td>
                <td class="gm-table-title">General Meeting of Alcomet's shareholders from 17.06.2015
                  <br><a href="/static/files/general_meetings/protokol-osa-17.06.2015.pdf" target="_blank" class="gm-table-link"><span class="alcomet gm-table-download">u</span><span class="gm-table-link-text">Protocol of Shareholders' General Meeting</span></a>
                </td>
              </tr>
              <tr class="gm-table-row">
                <td class="gm-table-date">20.06.2014</td>
                <td class="gm-table-title">General Meeting of Alcomet's shareholders from 20.06.2014
                  <br><a href="/static/files/general_meetings/protokol-osa-20.06.2014.pdf" target="_blank" class="gm-table-link"><span class="alcomet gm-table-download">u</span><span class="gm-table-link-text">Protocol of Shareholders' General Meeting</span></a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <app-share-button></app-share-button>
    </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
export default {
  components: {
    appShareButton: ShareButton
  }
};
</script>

<style scoped>
.investors-gm > p {
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
.gm-table-wrapper {
  border-radius: 6px;
  background-color: #edf2f4;
  margin: 30px auto 0;
  padding: 20px 10%;
  width: 80%;
}
.gm-table {
  border-collapse: collapse;
  margin: 0 auto;
  margin-left: -20px;
  width: calc(100% + 40px);
}
.gm-table tr,
.gm-table td {
  border-bottom: 1px solid #becddb;
  padding-bottom: 21px;
  padding-top: 21px;
}
.gm-table-main-title {
  font-size: 19px;
  font-weight: 500;
  padding-left: 20px;
  vertical-align: middle;
  width: 85%;
}
.gm-table-title-icon {
  color: #8eaec8;
  font-size: 28px;
  margin-right: 10px;
}
.gm-table-add {
  color: rgba(0, 71, 133, 0.5);
  font-size: 12px;
  text-align: right;
  padding-right: 20px;
  width: 15%;
}
.gm-table-date {
  font-size: 14px;
  padding-left: 20px;
  padding-right: 20px;
  vertical-align: baseline;
}
.gm-table-title {
  font-size: 16px;
  font-weight: 500;
  width: 78%;
  vertical-align: baseline;
}
.gm-table-link {
  align-items: center;
  display: inline-flex;
  margin-top: 30px;
}
.gm-table-link-text {
  color: #0086ff;
  font-size: 16px;
  font-weight: 500;
  text-decoration: underline;
}
.gm-table-download {
  font-size: 28px;
  margin-right: 14px;
}
@media screen and (max-width: 1000px) {
  .investors-gm > p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .gm-table-wrapper {
    width: calc(100% - 60px);
  }
  .gm-table {
    margin-left: 0;
    width: 100%;
  }
  .gm-table-main-title,
  .gm-table-date {
    padding-left: 0;
  }
  .gm-table-main-title {
    font-size: 18px;
  }
  .gm-table-title,
  .gm-table-link-text {
    font-size: 14px;
  }
  .gm-table-link {
    margin-top: 20px;
  }
}
@media screen and (max-width: 600px) {
  .gm-table-wrapper {
    padding: 0 20px 20px;
  }
  .gm-table-main-title {
    font-size: 14px;
  }
  .gm-table-title,
  .gm-table-link-text,
  .gm-table-date {
    font-size: 12px;
  }
  .gm-table-download {
    font-size: 22px;
    margin-right: 10px;
  }
}
@media screen and (max-width: 440px) {
  .gm-table tr,
  .gm-table td {
    border: none;
  }
  .gm-table tr {
    display: flex;
    flex-direction: column;
  }
  .gm-table .gm-table-row {
    padding: 0;
  }
  .gm-table .gm-table-main-title {
    border-bottom: none;
  }
  .gm-table .gm-table-date {
    border-bottom: 1px solid #becddb;
    padding-right: 0;
    padding-bottom: 10px;
    text-align: left;
  }
  .gm-table .gm-table-title {
    padding-top: 10px;
    width: 100%;
  }
  .gm-table-link {
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/investors/GeneralMeetings.vue